import React from 'react';
import NavigationBar from '../../ReusableComp/NavigationBar';
import  { PIFlowLeftNavBar } from '../../ReusableComp/NavBarLeft';
import { Col, Container, Row } from 'react-bootstrap';
import { useState } from 'react';
import ToggleButton from 'react-toggle-button';
import { useDispatch, useSelector } from 'react-redux';
import { getActionTaken, getAllCausalities, getAllOutComes } from '../../../Redux/actions/actions';
import { useEffect } from 'react';

const PIAdverseEvents = ( ) => {
    const dispatch = useDispatch();
const causalities = useSelector((state) => state.getCausalities);
const outComes = useSelector((state) => state.getOutComes);
const actnTakenOpts = useSelector((state) => state.actionTaken);

    const [currentPage, setCurrentPage] = useState(1)
    const [toggleSAE, setToggleSAE] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [btnTitle, setBtnTitle] = useState("");
    const [outComeId, setOutComeId] = useState('')
    const [causalityOptn, setCausalityOptn] = useState('')
    const [actionTakenId, setActionTakenId] = useState('')
    const [treatmentGiven, setTreatmentGiven] = useState("")
    const [fileNames, setFileNames] = useState([]);

    useEffect(() => {
            dispatch(getAllOutComes())
            dispatch(getActionTaken())
            dispatch(getAllCausalities())
        }, [dispatch, btnTitle])
     

    window.onkeydown = keypress;
function keypress(event) {
  if (event.keyCode == 27) {
    setShowPopup(false);
  }
}
const handleDragOver = (event) => {
    event.preventDefault();
};
const handleFileUpload = (event) => {
    const files = event.target.files;
    const newFileNames = Array.from(files).map((file) => file.name);
    setFileNames(newFileNames);
};

const handleDrop = (event) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    const newFileNames = Array.from(files).map((file) => file.name);
    setFileNames(newFileNames);
};
    function handleSearch(e) {
        setSearchTerm(e.target.value);
      }
    function handleOption(e) {
      setBtnTitle(e)
        setSearchTerm(e);
        setTimeout(() => {
          setShowPopup(false)
        }, 200);
      }
      function handleDropDown(){
        setShowPopup(!showPopup)
        setSearchTerm('');

      }
      const [showPopup, setShowPopup] = useState(false);
      const data = [
        { name: "Fever" },
        { name: "Swelling at or near injection site"},  
        { name: "Induration at or near injection site"},
        { name: "Nodule at injection site"},
        { name: "A local reaction at or near injection site"},
        { name: "Rash including mucosal involvement"},
        { name: "Anaphylaxis"},
        { name: "Generalized convulsive seizure "},
      ];

  const JustBtwn = "d-flex justify-content-between";

  const handleOptionChange=(e)=>{
    let id = e.target.id;
    let value = e.target.value;
switch(id){
case 'causality':
    if(value =='Select'){
        setCausalityOptn('');
    }else{
        setCausalityOptn(value);
    }
    break;
    case 'outCome':
    if(value =='Select'){
        setOutComeId('')
    }else{
        setOutComeId(value)
    }
    break;
    case 'actionTaken':
     if(value =='Select'){
        setActionTakenId('')
      }else{
        setActionTakenId(value)
      }
      break;
    case 'treatment_given':
     if(value =='Select'){
        setTreatmentGiven('')
      }else{
        setTreatmentGiven(value)
      }
      break;
    }}
      const maxDate = new Date().toISOString().split('T')[0];
    return (
        <div>
            <NavigationBar />
            {/* <PIFlowLeftNavBar /> */}
            <div className='main_body '>
                <Container fluid className='p-0 p-3'>
                    <Row className='d-flex justify-content-between'>
                    </Row>
                        <Row className='SVdtl_Main'>
                            <Col lg={3} md={3} sm={2} className='section_1'>
                                <div className='pisubj_left_main'>
                                    <div className='s1'>
                                       
                                        <div className='body_cls'>

                                      



                                        </div>
                                    </div>
                                </div>
                                <div className='px-3 s2'>
                                </div>
                            </Col>
                        <Col className=' pisub text-start p-4 d-flex gap-3 flex-column' >
                            <div className="d-flex justify-content-between ">
                    <div className="">
                      <label htmlFor="dateOfonSet" className="custm_label_fw">
                        Date of onset<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        // value={dataOfOnset}
                        className="customInput"
                        id="dateOfonSet"
                        type="date"
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "16px 12px", width: "340px" ,cursor: "not-allowed" }}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    </div>

                    <div className="">
                      <label htmlFor="timeOfonSet" className="custm_label_fw">
                        Time of onset (24 Hrs)
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        // value={timeOfOnset}
                        className="customInput"
                        id="timeOfonSet"
                        type="time"
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "16px 12px", width: "340px" }}
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <div className="">
                      <label
                        htmlFor="dateOfResolution"
                        className="custm_label_fw"
                      >
                        Date of resolution
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        // value={dataOfResolution}
                        className="customInput"
                        id="dateOfResolution"
                        max={maxDate}
                        type="date"
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "16px 12px", width: "340px",cursor: "not-allowed"  }}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    </div>

                    <div className="">
                      <label htmlFor="lastName" className="custm_label_fw">
                        Time of resolution (24 Hrs)
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        // value={timeOfResolution}
                        className="customInput"
                        id="lastName"
                        type="time"
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "16px 12px", width: "340px" }}
                      />
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <label htmlFor="lastName">
                      Is this a serious adverse criteria?
                    </label>
                    <span style={{ marginLeft: "20px" }}>
                      <ToggleButton value={toggleSAE}
                        onToggle={() => {
                          setToggleSAE(!toggleSAE);
                        }}
                        inactiveLabel={"No"}
                        activeLabel={"Yes"}
                        colors={{
                          activeThumb: {
                            base: "rgb(250,250,250)",
                          },
                          active: {
                            base: "rgb(209, 65, 65)",
                          },
                          inactive: {
                            base: "rgb((0, 128, 0)",
                          },
                        }}
                      />
                    </span>
                  </div>
                  <div className="d-flex justify-content-between my-3">
                      <label htmlFor="search_block">Adverse Event Classification</label>
                      <div className="search_block"  id='search_block'>
                                <div className="orange_btn" onClick={handleDropDown}
                                > {btnTitle.length>30?btnTitle.slice(0,30)+"...":btnTitle ||'Adverse Event'}
                                <img src="./images/icons/selectarrow.svg" alt=""/>
                                </div>
                                {showPopup && <div className="search_main"  onBlur={() => {
                                     setTimeout(() => {
                                       if (showPopup) {
                                         setShowPopup(false)
                                       }
                                     }, 200)
                                    }}>
                                    <div className='drop_down_for_search'>
                                        <input
                                            type="text"
                                            autoFocus
                                            value={searchTerm}
                                            onChange={handleSearch}
                                            placeholder="Search..."
                                        />
                                        <img className='sasd' src="./images/icons/search.svg" alt="" />
                                        <div className="eventlist_items">
                                            {data.filter(i => {
                                                const event = i.name || '';
                                                return event.toLowerCase().includes((searchTerm || '').toLowerCase())
                                            }).map((i, index) => {
                                                return (
                                                    <ul className='aelistdropdown' key={index}>
                                                        <li className={`${i.name===btnTitle ? 'selectedOption' :''}`} onClick={() => handleOption(i.name)}
                                                        >{i.name}</li>
                                                    </ul>
                                                    )})}
                                        </div></div>
                                </div>}
                            </div>
                  </div>


                  <div className={JustBtwn}>
                        <div className="">
                          <label htmlFor="causality">
                            Causality<span style={{ color: "red" }}>*</span>
                          </label>
                          <div className='custom_select_main'>
                              <select
                                id="causality"
                                value={causalityOptn}
                                className="selectTag"
                                style={{ width: "250px" }}
                                onChange={handleOptionChange}
                              >
                                <option value={"Select"}>Select</option>
                                {causalities &&
                                  causalities.map((i) => {
                                    return (
                                      <option
                                        key={i.causality_id}
                                        value={i.causality_id}
                                      >
                                        {i.causality_name}
                                      </option>
                                    );
                                  })}
                              </select>
                          </div>
                        </div>
                        <div className="">
                          <label htmlFor="outCome">
                            Outcome <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className='custom_select_main'>
                          <select
                            id="outCome"
                            className="selectTag"
                            value={outComeId}
                            style={{ width: "250px" }}
                            onChange={handleOptionChange}
                          >
                            <option value={"Select"}>
                             Select
                            </option>
                            {outComes &&
                              outComes.map((i) => {
                                return (
                                  <option value={i.outcome_id} key={i.outcome_id}>
                                    {i.outcome_name}
                                  </option>
                                );
                              })}
                          </select>
                          </div>
                        </div>
                        <div className="">
                          <label htmlFor="actionTaken">
                            Action Taken<span style={{ color: "red" }}>*</span>
                          </label>
                          <div className='custom_select_main'>
                          <select
                            id="actionTaken"
                            value={actionTakenId}
                            className="selectTag"
                            style={{ width: "250px" }}
                            onChange={handleOptionChange}
                          >
                            <option value={"Select"}>Select</option>
                            {actnTakenOpts &&
                              actnTakenOpts.map((i) => {
                                return (
                                  <option
                                    key={i.action_taken_id}
                                    value={i.action_taken_id}
                                  >
                                    {i.action_taken_name}
                                  </option>
                                );
                              })}
                          </select>
                          </div>
                        </div>
                      </div>
                      <div className={JustBtwn}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            marginTop: "20px",
                            width: "100%",
                            alignItems: "start",
                          }}
                        >
                          <label htmlFor="treatment_given">
                            Any treatment given
                          </label>
                          <textarea
                            id="treatment_given"
                            style={{
                              width: "100%",
                              minHeight: "100px",
                              borderColor: "#E1E5E7",
                              borderRadius: "8px",
                            }}
                            value={treatmentGiven}
                            placeholder="type here"
                            onChange={handleOptionChange}
                          />
                        </div>
                      </div>
                      <div>
                        <span
                          style={{ display: "flex", alignContent: "start" }}
                        >
                          <label htmlFor="file-input-label">Attach files</label>
                        </span>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "20px",
                          }}
                        >
                          <div
                            style={{ width: "500px", alignItems: "center" }}
                            id="drop-area"
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                          >
                            <div className="upload-icon" style={{}}>
                              <img
                                style={{
                                  height: "100px",
                                  margin: "6px",
                                  paddingLeft: "5px",
                                }}
                                src="./images/icons/Upload.svg"
                                alt=""
                              />
                              <h5>Drag and drop files here </h5>
                              <h5>or</h5>
                              <input
                                type="file"
                                id="file-input"
                                multiple
                                onChange={handleFileUpload}
                              />
                              <label
                                htmlFor="file-input"
                                className=""
                              >
                                <span className="gray_btn px-4">Browse Files</span>
                              </label>
                            </div>
                            <div id="file-list" style={{ margin: "10px" }}>
                              {fileNames.map((fileName) => (
                                <div key={fileName}>{fileName}</div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                       </Col>
                      
                        </Row>

                </Container>
            </div>
        </div>
    );
};

export default PIAdverseEvents;
 